import { Injectable } from '@angular/core';
import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ColorPickerValidator {
    validate(colorControlName: string, checkboxControlName: string): ValidatorFn {
        return (form: FormGroup): ValidationErrors | null => {
            const color = form.get(colorControlName).value;
            const setColor = form.get(checkboxControlName).value;

            if (setColor && !color) {
                return { 'hexColorRequired': 'Hex color is required' }
            }

            return null;
        }
    }
}
